// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2h1u6","errors":"Errors_errors__30H6G"};